export default __webpack_public_path__ + "static/media/settings.acc2fe64.svg";